"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[136],{

/***/ 3043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ PauseFilled; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _src_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(659);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e), o; if (Object.getOwnPropertySymbols) { o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { var r, t; for (r = 1; r < arguments.length; r++) { t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive], i; if (void 0 !== e) { i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var compPaths = {
  s: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5zm-7.5 0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.25 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5zm-7.5 0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5zm-7.5 0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.25 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5zm-7.5 0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M33 6c-3.308 0-6 2.692-6 6v24c0 3.308 2.692 6 6 6s6-2.692 6-6V12c0-3.308-2.692-6-6-6zM15 6c-3.308 0-6 2.692-6 6v24c0 3.308 2.692 6 6 6s6-2.692 6-6V12c0-3.308-2.692-6-6-6z",
    clipRule: "evenodd"
  }))
};
var PauseFilled = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().memo(function (props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_src_index__WEBPACK_IMPORTED_MODULE_1__/* .SvgIcon */ .l, _objectSpread(_objectSpread({}, props), {}, {
    paths: compPaths,
    fill: "none"
  }));
});

/***/ }),

/***/ 59153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ CaretLeft; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _src_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(659);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e), o; if (Object.getOwnPropertySymbols) { o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { var r, t; for (r = 1; r < arguments.length; r++) { t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive], i; if (void 0 !== e) { i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var compPaths = {
  s: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.75 17.5L9.25 12l5.5-5.5"
  })),
  m: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.525 18.966L8.558 12l6.967-6.967"
  })),
  l: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.05 37.932L17.118 24 31.05 10.066"
  }))
};
var CaretLeft = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().memo(function (props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_src_index__WEBPACK_IMPORTED_MODULE_1__/* .SvgIcon */ .l, _objectSpread(_objectSpread({}, props), {}, {
    paths: compPaths,
    fill: "none"
  }));
});

/***/ }),

/***/ 31487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ CaretRight; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _src_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(659);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e), o; if (Object.getOwnPropertySymbols) { o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { var r, t; for (r = 1; r < arguments.length; r++) { t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive], i; if (void 0 !== e) { i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var compPaths = {
  s: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 17.5l5.5-5.5-5.5-5.5"
  })),
  m: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.474 18.966L15.44 12 8.474 5.033"
  })),
  l: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.947 37.932L30.881 24 16.947 10.066"
  }))
};
var CaretRight = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().memo(function (props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_src_index__WEBPACK_IMPORTED_MODULE_1__/* .SvgIcon */ .l, _objectSpread(_objectSpread({}, props), {}, {
    paths: compPaths,
    fill: "none"
  }));
});

/***/ }),

/***/ 58136:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AutoplayCarousel": function() { return /* reexport */ AutoplayCarousel; },
  "NavigationButtons": function() { return /* reexport */ NavigationButtons; },
  "PaginationIndicators": function() { return /* reexport */ PaginationIndicators; },
  "ProgressPauseButton": function() { return /* reexport */ ProgressPauseButton; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/esm/_define_property.js
var _define_property = __webpack_require__(20606);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/esm/_object_spread.js
var _object_spread = __webpack_require__(24022);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/esm/_object_spread_props.js
var _object_spread_props = __webpack_require__(4670);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/esm/_to_consumable_array.js + 3 modules
var _to_consumable_array = __webpack_require__(56503);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__(37667);
var external_React_default = /*#__PURE__*/__webpack_require__.n(external_React_);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(17635);
// EXTERNAL MODULE: ../ciclp-react-components/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(26490);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/@nike/nike-design-system-components/esm/prod/hooks/useBreakpoint.js + 1 modules
var useBreakpoint = __webpack_require__(21315);
// EXTERNAL MODULE: ../../node_modules/@nike/nike-design-system-components/esm/prod/hooks/useMatchMedia.js
var useMatchMedia = __webpack_require__(46477);
// EXTERNAL MODULE: ../ciclp-redux-app/src/index.js + 228 modules
var src = __webpack_require__(68978);
// EXTERNAL MODULE: ../ciclp-redux-app/src/analytics/constants.js
var constants = __webpack_require__(8290);
;// CONCATENATED MODULE: ../ciclp-react-components/src/components/autoplayCarousel/autoplayCarousel.styl
// extracted by mini-css-extract-plugin
/* harmony default export */ var autoplayCarousel = ({"autoplayCarousel":"MDDLJwBF","slidesContainer":"_3PRbJZnK","slide":"_3rlks-sl","controls":"_3LX_QbmP","progressButton":"_2qZJUZJp","dark":"_2a8LwOjT","progressBar":"_1KMgAAcp","progressTrack":"_21Ov18W_","playPause":"_1XkXVf2u","navBtnContainer":"_1qT6E0di","navButton":"_3fh4aDHS","caret":"_2gOsEWii","pagination":"S2QRw7W4","paginationDot":"TYczRBi0","active":"Eh9hXxQZ","transitioning":"_2TL9vIWH","parallaxNext":"_1z17BcHA","parallaxFromRight":"_22kD7MgC","parallaxPrev":"_3l-dojV_","parallaxFromLeft":"_1Io7Ckl7"});
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/esm/_object_without_properties.js + 1 modules
var _object_without_properties = __webpack_require__(83286);
// EXTERNAL MODULE: ../ciclp-react-components/src/components/videoCard/index.js + 5 modules
var videoCard = __webpack_require__(61597);
// EXTERNAL MODULE: ../ciclp-react-components/src/components/imageCard/index.js + 1 modules
var imageCard = __webpack_require__(64401);
// EXTERNAL MODULE: ../ciclp-react-components/src/shapes/index.js
var shapes = __webpack_require__(49528);
;// CONCATENATED MODULE: ../ciclp-react-components/src/components/autoplayCarousel/constants.js
var TRANSITION_DURATION = 1000;
var DEFAULT_IMAGE_SLIDE_DELAY = 6000;
var DEFAULT_VIDEO_SLIDE_DELAY = 7000;
var DEFAULT_VIDEO_SLIDE_DELAY_SECONDS = 7;
// Local constants to avoid external dependencies
var CARD_TYPES = {
    IMAGE: "IMAGE",
    VIDEO: "VIDEO"
};

;// CONCATENATED MODULE: ../ciclp-react-components/src/components/autoplayCarousel/autoplayCarouselSlide.js











var AutoplayCarouselSlide = function(_param) {
    var _analyticsItemId = _param.analyticsItemId, analyticsItemId = _analyticsItemId === void 0 ? "" : _analyticsItemId, _hashKey = _param.hashKey, hashKey = _hashKey === void 0 ? "" : _hashKey, _colorTheme = _param.colorTheme, colorTheme = _colorTheme === void 0 ? shapes/* THEMES.LIGHT */.yU.LIGHT : _colorTheme, _index = _param.index, index = _index === void 0 ? 0 : _index, _itemCount = _param.itemCount, itemCount = _itemCount === void 0 ? 0 : _itemCount, _collectionId = _param.collectionId, collectionId = _collectionId === void 0 ? "" : _collectionId, onAutoplayControl = _param.onAutoplayControl, slide = (0,_object_without_properties._)(_param, [
        "analyticsItemId",
        "hashKey",
        "colorTheme",
        "index",
        "itemCount",
        "collectionId",
        "onAutoplayControl"
    ]);
    var ref;
    var actionButtons = slide === null || slide === void 0 ? void 0 : slide.actionButtons;
    var actionHashKeys = Array.isArray(actionButtons) ? actionButtons.map(function(btn) {
        var ref;
        return (ref = btn.analytics) === null || ref === void 0 ? void 0 : ref.hashKey;
    }).filter(Boolean) : [];
    var slideContainerType = slide === null || slide === void 0 ? void 0 : (ref = slide.containerType) === null || ref === void 0 ? void 0 : ref.toUpperCase();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-analytics-placement-id": analyticsItemId,
        "data-is-carousel-content": slide === null || slide === void 0 ? void 0 : slide.isInCarousel,
        "data-action-hashkeys": actionHashKeys,
        "data-click-mod": hashKey,
        "data-index": index,
        "data-collection-id": collectionId,
        "data-item-count": itemCount,
        "data-analytics-has-landmark": "true",
        "data-qa": "autoplay-carousel-item",
        className: autoplayCarousel.slide,
        children: slideContainerType === CARD_TYPES.VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsx)(videoCard/* VideoCard */.c, (0,_object_spread_props._)((0,_object_spread._)({}, slide), {
            dataAnalyticsHasLandmark: false,
            colorTheme: colorTheme,
            controlOptions: slide === null || slide === void 0 ? void 0 : slide.controlOptions,
            preset: "ambient",
            inSwiperCarousel: true,
            loop: false,
            onAutoplayControl: onAutoplayControl
        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(imageCard/* default */.Z, (0,_object_spread_props._)((0,_object_spread._)({}, slide), {
            dataAnalyticsHasLandmark: false,
            colorTheme: colorTheme
        }))
    });
};
AutoplayCarouselSlide.propTypes = (0,_object_spread_props._)((0,_object_spread._)({}, shapes/* gallerySlideShape */.zA), {
    analyticsItemId: (prop_types_default()).string,
    collectionId: (prop_types_default()).string,
    hashKey: (prop_types_default()).string,
    index: (prop_types_default()).number,
    itemCount: (prop_types_default()).number,
    onAutoplayControl: (prop_types_default()).func
});

// EXTERNAL MODULE: ../../node_modules/@nike/nike-design-system-icons/esm/prod/react-icons/Standard/UINavigation/CaretLeft.js
var CaretLeft = __webpack_require__(59153);
// EXTERNAL MODULE: ../../node_modules/@nike/nike-design-system-icons/esm/prod/react-icons/Standard/UINavigation/CaretRight.js
var CaretRight = __webpack_require__(31487);
;// CONCATENATED MODULE: ../ciclp-react-components/src/components/autoplayCarousel/NavigationButtons.js








var NavigationButtons = /*#__PURE__*/ external_React_default().memo(function(param) {
    var _colorTheme = param.colorTheme, colorTheme = _colorTheme === void 0 ? shapes/* THEMES.LIGHT */.yU.LIGHT : _colorTheme, onPrevClick = param.onPrevClick, onNextClick = param.onNextClick, _translations = param.translations, translations = _translations === void 0 ? {} : _translations;
    var navButtonClasses = (0,clsx_m/* default */.Z)(autoplayCarousel.navButton, (0,_define_property._)({}, autoplayCarousel.dark, colorTheme === shapes/* THEMES.DARK */.yU.DARK));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: autoplayCarousel.navBtnContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: navButtonClasses,
                "aria-label": translations.prevButton || "Previous slide",
                onClick: onPrevClick,
                type: "button",
                "data-qa": "prev-btn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretLeft/* CaretLeft */.W, {
                    className: autoplayCarousel.caret,
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: navButtonClasses,
                "aria-label": translations.nextButton || "Next slide",
                onClick: onNextClick,
                type: "button",
                "data-qa": "next-btn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaretRight/* CaretRight */.T, {
                    className: autoplayCarousel.caret,
                    "aria-hidden": "true"
                })
            })
        ]
    });
});
NavigationButtons.displayName = "NavigationButtons";
NavigationButtons.propTypes = {
    colorTheme: (prop_types_default()).string,
    onNextClick: (prop_types_default()).func.isRequired,
    onPrevClick: (prop_types_default()).func.isRequired,
    translations: prop_types_default().objectOf((prop_types_default()).string)
};

// EXTERNAL MODULE: ../../node_modules/@nike/nike-design-system-icons/esm/prod/react-icons/Standard/MediaControls/PauseFilled.js
var PauseFilled = __webpack_require__(3043);
// EXTERNAL MODULE: ../../node_modules/@nike/nike-design-system-icons/esm/prod/react-icons/Standard/MediaControls/PlayFilled.js
var PlayFilled = __webpack_require__(40174);
;// CONCATENATED MODULE: ../ciclp-react-components/src/components/autoplayCarousel/ProgressPauseButton.js








var ProgressPauseButton = /*#__PURE__*/ external_React_default().memo(function(param) {
    var _colorTheme = param.colorTheme, colorTheme = _colorTheme === void 0 ? shapes/* THEMES.LIGHT */.yU.LIGHT : _colorTheme, _isAutoPlaying = param.isAutoPlaying, isAutoPlaying = _isAutoPlaying === void 0 ? false : _isAutoPlaying, progressCircleRef = param.progressCircleRef, onPlayPauseClick = param.onPlayPauseClick, onFocus = param.onFocus, _translations = param.translations, translations = _translations === void 0 ? {} : _translations;
    var _obj;
    var progressButtonClasses = (0,clsx_m/* default */.Z)(autoplayCarousel.progressButton, (_obj = {}, (0,_define_property._)(_obj, autoplayCarousel.dark, colorTheme === shapes/* THEMES.DARK */.yU.DARK), (0,_define_property._)(_obj, autoplayCarousel.paused, !isAutoPlaying), _obj));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: progressButtonClasses,
        onClick: onPlayPauseClick,
        onFocus: onFocus,
        "aria-label": isAutoPlaying ? translations.autoplayPauseButtonLabel || "Pause autoplay" : translations.autoplayResumeButtonLabel || "Resume autoplay",
        type: "button",
        "data-qa": "progress-pause-btn",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                viewBox: "0 0 48 48",
                className: autoplayCarousel.progressTrack,
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "24",
                    cy: "24",
                    r: "22"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                viewBox: "0 0 48 48",
                ref: progressCircleRef,
                className: autoplayCarousel.progressBar,
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "24",
                    cy: "24",
                    r: "22"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: autoplayCarousel.playPause,
                "aria-hidden": "true",
                children: isAutoPlaying ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PauseFilled/* PauseFilled */.L, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayFilled/* PlayFilled */.E, {})
            })
        ]
    });
});
ProgressPauseButton.displayName = "ProgressPauseButton";
ProgressPauseButton.propTypes = {
    colorTheme: (prop_types_default()).string,
    isAutoPlaying: (prop_types_default()).bool,
    onFocus: (prop_types_default()).func,
    onPlayPauseClick: (prop_types_default()).func,
    progressCircleRef: prop_types_default().oneOfType([
        (prop_types_default()).func,
        prop_types_default().shape({
            current: (prop_types_default()).any
        }), 
    ]),
    translations: prop_types_default().shape({
        autoplayPauseButtonLabel: (prop_types_default()).string,
        autoplayResumeButtonLabel: (prop_types_default()).string
    })
};

;// CONCATENATED MODULE: ../ciclp-react-components/src/components/autoplayCarousel/PaginationIndicators.js







var PaginationIndicators = function(param) {
    var slides = param.slides, activeSlideIndex = param.activeSlideIndex, onSlideClick = param.onSlideClick, paginationLabel = param.paginationLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: autoplayCarousel.pagination,
        role: "group",
        "aria-label": paginationLabel,
        children: slides === null || slides === void 0 ? void 0 : slides.map(function(slide, index) {
            var isActive = index === activeSlideIndex;
            var ref;
            var slideKey = (ref = slide === null || slide === void 0 ? void 0 : slide.id) !== null && ref !== void 0 ? ref : "slide-".concat(index);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: (0,clsx_m/* default */.Z)(autoplayCarousel.paginationDot, (0,_define_property._)({}, autoplayCarousel.active, isActive)),
                onClick: function() {
                    return onSlideClick(index);
                },
                "aria-label": "".concat(isActive ? "Current slide, " : "", "Go to slide ").concat(index + 1, " of ").concat(slides.length),
                "aria-current": isActive ? "true" : undefined,
                type: "button"
            }, "pagination-".concat(slideKey));
        })
    });
};
PaginationIndicators.propTypes = {
    activeSlideIndex: (prop_types_default()).number.isRequired,
    onSlideClick: (prop_types_default()).func.isRequired,
    paginationLabel: (prop_types_default()).string,
    slides: prop_types_default().arrayOf(prop_types_default().shape(shapes/* gallerySlideShape */.zA))
};

// EXTERNAL MODULE: ../ciclp-react-components/src/context/index.js
var context = __webpack_require__(16946);
// EXTERNAL MODULE: ../ciclp-react-components/src/components/videoMedia/helpers/index.js
var helpers = __webpack_require__(32434);
// EXTERNAL MODULE: ../ciclp-react-components/src/context/videoMetadataContext.js
var context_videoMetadataContext = __webpack_require__(77625);
;// CONCATENATED MODULE: ../ciclp-react-components/src/components/autoplayCarousel/hooks.js





var useGetSlideDelay = function() {
    var isPortrait = (0,context/* useDimensionTypeContext */.Z8)().isPortrait;
    var videoMetadataContext = (0,context_videoMetadataContext/* useVideoMetadataContext */.ZJ)();
    return function(slide) {
        var ref, ref1;
        var isVideoSlide = (slide === null || slide === void 0 ? void 0 : (ref = slide.containerType) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === CARD_TYPES.VIDEO;
        if (!isVideoSlide) {
            return DEFAULT_IMAGE_SLIDE_DELAY;
        }
        var renderedVideoId = (0,helpers/* resolveVideoParams */.FG)((0,_object_spread._)({
            isPortrait: isPortrait
        }, slide)).renderedVideoId;
        var durationInSeconds = (ref1 = videoMetadataContext[renderedVideoId]) === null || ref1 === void 0 ? void 0 : ref1.durationInSeconds;
        // Use actual video duration if shorter than default, otherwise use default
        if (durationInSeconds && durationInSeconds < DEFAULT_VIDEO_SLIDE_DELAY_SECONDS) {
            return durationInSeconds * 1000;
        }
        return DEFAULT_VIDEO_SLIDE_DELAY;
    };
};

;// CONCATENATED MODULE: ../ciclp-react-components/src/components/autoplayCarousel/carouselUtils.js


// Constants
var FOCUSABLE_ELEMENTS_SELECTOR = "a, button, input, textarea, select, details, [tabindex]:not(video, .vjs-poster, .video-js)";
var VIDEO_PLAYER_SELECTOR = "[data-vjs-player]";
// Helper to get video player from a slide element
var getVideoPlayer = function(slide) {
    var ref, ref1;
    return (slide === null || slide === void 0 ? void 0 : (ref = slide.querySelector) === null || ref === void 0 ? void 0 : (ref1 = ref.call(slide, VIDEO_PLAYER_SELECTOR)) === null || ref1 === void 0 ? void 0 : ref1.player) || null;
};
// Helper to stop and reset a video player
var stopAndResetVideo = function(player) {
    if (player) {
        player.pause();
        player.currentTime(0);
    }
};
// Helper to reset touch state
var resetTouchState = function(touchStateRef) {
    touchStateRef.current.startX = null;
    touchStateRef.current.startY = null;
    touchStateRef.current.startTime = null;
    touchStateRef.current.wasAutoPlaying = null;
};
// Helper to clear autoplay timers
var clearAutoplayTimers = function(timerRef, timeLeftRef) {
    if (timerRef.current) {
        clearTimeout(timerRef.current);
    }
    if (timeLeftRef.current) {
        cancelAnimationFrame(timeLeftRef.current);
    }
};
/**
 * Carousel utility functions
 */ var useCarouselUtils = function(param) {
    var carouselRef = param.carouselRef, currentTransformIndex = param.currentTransformIndex, slides = param.slides, activeSlideIndex = param.activeSlideIndex, translations = param.translations, isTransitioning = param.isTransitioning, setIsTransitioning = param.setIsTransitioning, setActiveSlideIndex = param.setActiveSlideIndex, setCurrentTransformIndex = param.setCurrentTransformIndex, timerRef = param.timerRef, timeLeftRef = param.timeLeftRef, isAutoPlaying = param.isAutoPlaying, getSlideDelay = param.getSlideDelay, progressCircle = param.progressCircle, isMobile = param.isMobile, prefersReducedMotion = param.prefersReducedMotion, slidesFullControlsEnabled = param.slidesFullControlsEnabled, touchStateRef = param.touchStateRef, transitionTimeoutRef = param.transitionTimeoutRef, setTransitionDirection = param.setTransitionDirection;
    // Video management functions
    // Note: We intentionally DON'T try to play videos from the carousel.
    // The videoMedia's pause-on-leave plugin handles autoplay via IntersectionObserver.
    // The carousel only stops/resets inactive videos to avoid conflicts.
    var getActiveSlideVideoPlayer = (0,external_React_.useCallback)(function() {
        if (!carouselRef.current) return null;
        var activeSlide = carouselRef.current.children[currentTransformIndex];
        return getVideoPlayer(activeSlide);
    }, [
        carouselRef,
        currentTransformIndex
    ]);
    var pauseVideo = (0,external_React_.useCallback)(function() {
        var ref;
        (ref = getActiveSlideVideoPlayer()) === null || ref === void 0 ? void 0 : ref.pause();
    }, [
        getActiveSlideVideoPlayer
    ]);
    var resumeVideo = (0,external_React_.useCallback)(function() {
        var ref;
        (ref = getActiveSlideVideoPlayer()) === null || ref === void 0 ? void 0 : ref.play();
    }, [
        getActiveSlideVideoPlayer
    ]);
    // Restart video from beginning (reset to 0 and play)
    var restartVideo = (0,external_React_.useCallback)(function() {
        var player = getActiveSlideVideoPlayer();
        if (player) {
            player.currentTime(0);
            player.play();
        }
    }, [
        getActiveSlideVideoPlayer
    ]);
    /**
   * Stop and reset videos on INACTIVE slides only.
   * This prevents old videos from continuing to play when they slide out of view.
   * We don't touch the active slide - the pause-on-leave plugin will handle autoplay.
   */ var stopInactiveVideos = (0,external_React_.useCallback)(function() {
        if (!carouselRef.current) return;
        var realSlideCount = (slides === null || slides === void 0 ? void 0 : slides.length) || 0;
        // DOM structure: [lastDuplicate (0), ...realSlides (1 to N), firstDuplicate (N+1)]
        Array.from(carouselRef.current.children).forEach(function(slide, domIndex) {
            var isDuplicate = domIndex === 0 || domIndex === realSlideCount + 1;
            var isActiveSlide = domIndex === currentTransformIndex;
            // Skip duplicates and active slide
            if (isDuplicate || isActiveSlide) return;
            stopAndResetVideo(getVideoPlayer(slide));
        });
    }, [
        carouselRef,
        slides === null || slides === void 0 ? void 0 : slides.length,
        currentTransformIndex
    ]);
    /**
   * Stop and reset ALL videos including the active slide.
   * Used for component unmount cleanup to ensure proper disposal.
   */ var stopAllVideos = (0,external_React_.useCallback)(function() {
        if (!carouselRef.current) return;
        Array.from(carouselRef.current.children).forEach(function(slide) {
            stopAndResetVideo(getVideoPlayer(slide));
        });
    }, [
        carouselRef
    ]);
    var isActiveSlideVideo = (0,external_React_.useCallback)(function() {
        var ref, ref1;
        return ((ref = slides[activeSlideIndex]) === null || ref === void 0 ? void 0 : (ref1 = ref.containerType) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase()) === "VIDEO";
    }, [
        slides,
        activeSlideIndex
    ]);
    // Helper functions
    var updateFocusableElements = (0,external_React_.useCallback)(function(slideIndex) {
        if (!carouselRef.current) {
            return;
        }
        var slideElements = Array.from(carouselRef.current.children);
        var realSlideCount = (slides === null || slides === void 0 ? void 0 : slides.length) || 0;
        // DOM structure: [lastDuplicate, ...realSlides, firstDuplicate]
        // So real slides are at DOM indices 1 through realSlideCount
        slideElements.forEach(function(slide, domIndex) {
            var focusableElements = slide === null || slide === void 0 ? void 0 : slide.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR);
            // Check if this is a duplicate slide (first or last in DOM)
            var isDuplicate = domIndex === 0 || domIndex === realSlideCount + 1;
            // Real slides start at DOM index 1, so active slide is at domIndex = slideIndex + 1
            var isActive = !isDuplicate && domIndex === slideIndex + 1;
            focusableElements.forEach(function(el) {
                el.setAttribute("tabindex", isActive ? "0" : "-1");
            });
            slide === null || slide === void 0 ? void 0 : slide.setAttribute("aria-hidden", !isActive);
            // For duplicates, don't set a meaningful aria-label (they're hidden anyway)
            // For real slides, calculate the actual slide number (1-based)
            if (!isDuplicate) {
                var ref, ref1, ref2, ref3;
                var actualSlideNumber = domIndex; // domIndex 1 = slide 1, domIndex 2 = slide 2, etc.
                var slideData = slides[domIndex - 1]; // slides array is 0-indexed
                var isVideo = (slideData === null || slideData === void 0 ? void 0 : (ref = slideData.containerType) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === "VIDEO";
                var mediaType = isVideo ? "video" : "image";
                var slideTitle = slideData === null || slideData === void 0 ? void 0 : (ref1 = slideData.titleProps) === null || ref1 === void 0 ? void 0 : ref1.text;
                var titleSuffix = slideTitle ? ": ".concat(slideTitle) : "";
                var baseLabel = ((ref3 = (ref2 = translations.autoplaySlideNumber) === null || ref2 === void 0 ? void 0 : ref2.replace("{slideNum}", actualSlideNumber)) === null || ref3 === void 0 ? void 0 : ref3.replace("{slidesTotalNum}", realSlideCount)) || "Slide ".concat(actualSlideNumber, " of ").concat(realSlideCount);
                var label = "".concat(baseLabel, ", ").concat(mediaType).concat(titleSuffix);
                slide.setAttribute("aria-label", label);
            }
        });
    }, [
        carouselRef,
        translations,
        slides
    ]);
    // Navigation functions
    var goToSlide = (0,external_React_.useCallback)(function(newIndex) {
        if (isTransitioning || !(slides === null || slides === void 0 ? void 0 : slides.length)) {
            return;
        }
        // Note: stopAllVideos() is called AFTER the transition completes
        // in the video management effect in autoplayCarousel.js
        // Clear any existing transition timeout to prevent race conditions
        if (transitionTimeoutRef.current) {
            clearTimeout(transitionTimeoutRef.current);
            transitionTimeoutRef.current = null;
        }
        setIsTransitioning(true);
        // Calculate the actual slide index (0-based)
        var nextSlideIndex = (newIndex % slides.length + slides.length) % slides.length;
        // Calculate transform index (includes duplicates)
        // Priority: check simple +1/-1 steps first, then wrap cases
        // This prevents 2-slide carousels from incorrectly matching wrap conditions
        var nextTransformIndex;
        if (newIndex === activeSlideIndex + 1) {
            // Moving forward one step
            nextTransformIndex = currentTransformIndex + 1;
        } else if (newIndex === activeSlideIndex - 1) {
            // Moving backward one step
            nextTransformIndex = currentTransformIndex - 1;
        } else if (activeSlideIndex === slides.length - 1 && newIndex === 0) {
            // Wrapping from last to first (forward via autoplay/next at boundary)
            nextTransformIndex = currentTransformIndex + 1;
        } else if (activeSlideIndex === 0 && newIndex === slides.length - 1) {
            // Wrapping from first to last (backward via prev at boundary)
            nextTransformIndex = currentTransformIndex - 1;
        } else {
            // Direct navigation to specific slide (e.g., pagination click)
            nextTransformIndex = newIndex + 1; // +1 to account for duplicate at start
        }
        // Determine parallax transition direction based on transform movement
        var direction = null;
        if (nextTransformIndex > currentTransformIndex) {
            direction = "next";
        } else if (nextTransformIndex < currentTransformIndex) {
            direction = "prev";
        }
        setTransitionDirection(direction);
        setActiveSlideIndex(nextSlideIndex);
        setCurrentTransformIndex(nextTransformIndex);
        clearAutoplayTimers(timerRef, timeLeftRef);
        // Reset progress to 0 when changing slides
        if (progressCircle.current) {
            progressCircle.current.style.setProperty("--progress", 0);
        }
        // Store the timeout reference to allow cancellation
        // When reduced motion is preferred, transition is instant so use minimal delay
        var transitionDelay = prefersReducedMotion ? 0 : TRANSITION_DURATION;
        transitionTimeoutRef.current = setTimeout(function() {
            // Handle infinite scroll reset
            if (nextTransformIndex >= slides.length + 1) {
                // We've moved past the last duplicate, reset to first real slide
                setCurrentTransformIndex(1);
            } else if (nextTransformIndex <= 0) {
                // We've moved before the first duplicate, reset to last real slide
                setCurrentTransformIndex(slides.length);
            }
            setIsTransitioning(false);
            setTransitionDirection(null);
            updateFocusableElements(nextSlideIndex);
            transitionTimeoutRef.current = null;
        }, transitionDelay);
    }, [
        isTransitioning,
        slides,
        activeSlideIndex,
        currentTransformIndex,
        prefersReducedMotion,
        setIsTransitioning,
        setTransitionDirection,
        setActiveSlideIndex,
        setCurrentTransformIndex,
        timerRef,
        timeLeftRef,
        progressCircle,
        updateFocusableElements,
        transitionTimeoutRef, 
    ]);
    var goToNextSlide = (0,external_React_.useCallback)(function() {
        goToSlide(activeSlideIndex + 1);
    }, [
        activeSlideIndex,
        goToSlide
    ]);
    var goToPrevSlide = (0,external_React_.useCallback)(function() {
        goToSlide(activeSlideIndex - 1);
    }, [
        activeSlideIndex,
        goToSlide
    ]);
    // Autoplay logic
    var startAutoplay = (0,external_React_.useCallback)(function() {
        if (!isAutoPlaying || isTransitioning) {
            return;
        }
        var currentSlide = slides[activeSlideIndex];
        var delay = getSlideDelay(currentSlide) || DEFAULT_IMAGE_SLIDE_DELAY;
        clearAutoplayTimers(timerRef, timeLeftRef);
        // Get current progress (either stored from pause or 0 for new slide)
        var currentProgress = progressCircle.current ? parseFloat(progressCircle.current.style.getPropertyValue("--progress") || "0") : 0;
        // Calculate remaining time based on current progress
        var elapsed = currentProgress * delay;
        var remainingDelay = Math.max(0, delay - elapsed);
        // Timer for advancing slide
        timerRef.current = setTimeout(function() {
            if (isAutoPlaying) {
                goToNextSlide();
            }
        }, remainingDelay);
        // Use requestAnimationFrame for smoother progress updates
        var startTime = performance.now() - elapsed; // Adjust start time for current progress
        var updateProgress = function() {
            var elapsedTotal = performance.now() - startTime;
            var remaining = Math.max(0, delay - elapsedTotal);
            // Update progress circle
            var progress = 1 - remaining / delay;
            if (progressCircle.current) {
                progressCircle.current.style.setProperty("--progress", progress);
            }
            if (remaining > 0) {
                timeLeftRef.current = requestAnimationFrame(updateProgress);
            }
        };
        timeLeftRef.current = requestAnimationFrame(updateProgress);
    }, [
        isAutoPlaying,
        isTransitioning,
        activeSlideIndex,
        slides,
        getSlideDelay,
        goToNextSlide,
        timerRef,
        timeLeftRef,
        progressCircle, 
    ]);
    var stopAutoplay = (0,external_React_.useCallback)(function() {
        clearAutoplayTimers(timerRef, timeLeftRef);
    // Note: Don't reset progress - it's preserved for resume
    // Progress resets to 0 only when slide changes in goToSlide
    }, [
        timerRef,
        timeLeftRef
    ]);
    // Touch/swipe handling for mobile
    var handleTouchStart = (0,external_React_.useCallback)(function(e, onPauseAutoplay) {
        var ref;
        if (!isMobile && slidesFullControlsEnabled) {
            return;
        }
        var touch = (ref = e.touches) === null || ref === void 0 ? void 0 : ref[0];
        if (!touch) return;
        touchStateRef.current.startX = touch.clientX;
        touchStateRef.current.startY = touch.clientY;
        touchStateRef.current.startTime = performance.now();
        touchStateRef.current.wasAutoPlaying = isAutoPlaying;
        // Pause autoplay during touch interaction
        if (isAutoPlaying && onPauseAutoplay) {
            onPauseAutoplay();
        }
    }, [
        isMobile,
        slidesFullControlsEnabled,
        touchStateRef,
        isAutoPlaying
    ]);
    var handleTouchEnd = (0,external_React_.useCallback)(function(e, handleNextClick, handlePrevClick, onResumeAutoplay) {
        var ref;
        if (!isMobile && slidesFullControlsEnabled) {
            return;
        }
        if (!touchStateRef.current.startX || !touchStateRef.current.startY) {
            return;
        }
        var touch = (ref = e.changedTouches) === null || ref === void 0 ? void 0 : ref[0];
        if (!touch) {
            resetTouchState(touchStateRef);
            return;
        }
        var diffX = touchStateRef.current.startX - touch.clientX;
        var diffY = touchStateRef.current.startY - touch.clientY;
        var elapsedTime = performance.now() - (touchStateRef.current.startTime || 0);
        // Responsive swipe threshold: 10% of viewport width, min 30px, max 50px
        var viewportWidth = window.innerWidth;
        var swipeThreshold = Math.max(30, Math.min(50, viewportWidth * 0.1));
        // Velocity-based detection: allow quick flicks with shorter distance
        // Velocity = pixels per millisecond
        var velocity = Math.abs(diffX) / elapsedTime;
        var isQuickFlick = velocity > 0.5 && Math.abs(diffX) > 20; // Fast swipe with minimal distance
        // Only handle horizontal swipes
        var isHorizontalSwipe = Math.abs(diffX) > Math.abs(diffY);
        var meetsDistanceThreshold = Math.abs(diffX) > swipeThreshold;
        if (isHorizontalSwipe && (meetsDistanceThreshold || isQuickFlick)) {
            if (diffX > 0) {
                handleNextClick();
            } else {
                handlePrevClick();
            }
        }
        // Resume autoplay if it was playing before touch
        if (touchStateRef.current.wasAutoPlaying && onResumeAutoplay) {
            onResumeAutoplay();
        }
        resetTouchState(touchStateRef);
    }, [
        isMobile,
        slidesFullControlsEnabled,
        touchStateRef
    ]);
    var handleTouchCancel = (0,external_React_.useCallback)(function(onResumeAutoplay) {
        if (!touchStateRef.current) return;
        // Resume autoplay if it was playing before touch
        if (touchStateRef.current.wasAutoPlaying && onResumeAutoplay) {
            onResumeAutoplay();
        }
        resetTouchState(touchStateRef);
    }, [
        touchStateRef
    ]);
    return {
        getActiveSlideVideoPlayer: getActiveSlideVideoPlayer,
        goToNextSlide: goToNextSlide,
        goToPrevSlide: goToPrevSlide,
        goToSlide: goToSlide,
        // Touch functions
        handleTouchCancel: handleTouchCancel,
        handleTouchEnd: handleTouchEnd,
        handleTouchStart: handleTouchStart,
        // Slide helpers
        isActiveSlideVideo: isActiveSlideVideo,
        pauseVideo: pauseVideo,
        restartVideo: restartVideo,
        resumeVideo: resumeVideo,
        // Autoplay functions
        startAutoplay: startAutoplay,
        stopAllVideos: stopAllVideos,
        stopAutoplay: stopAutoplay,
        stopInactiveVideos: stopInactiveVideos,
        // Helper functions
        updateFocusableElements: updateFocusableElements
    };
};

;// CONCATENATED MODULE: ../ciclp-react-components/src/components/autoplayCarousel/autoplayCarousel.js





















// Visually hidden styles for screen reader live region
var srOnlyStyles = {
    height: "1px",
    left: "-10000px",
    overflow: "hidden",
    position: "absolute",
    width: "1px"
};
var AutoplayCarousel = function(param) {
    var _slides = param.slides, slides = _slides === void 0 ? [] : _slides, _analyticsItemId = param.analyticsItemId, analyticsItemId = _analyticsItemId === void 0 ? "" : _analyticsItemId, _cardId = param.cardId, cardId = _cardId === void 0 ? "" : _cardId, _hashKey = param.hashKey, hashKey = _hashKey === void 0 ? "" : _hashKey, _translations = param.translations, translations = _translations === void 0 ? {} : _translations;
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,external_React_.useState)(0), activeSlideIndex = ref1[0], setActiveSlideIndex = ref1[1];
    var ref2 = (0,external_React_.useState)(true), isAutoPlaying = ref2[0], setIsAutoPlaying = ref2[1];
    var ref3 = (0,external_React_.useState)(false), isTransitioning = ref3[0], setIsTransitioning = ref3[1];
    var ref4 = (0,external_React_.useState)(1), currentTransformIndex = ref4[0], setCurrentTransformIndex = ref4[1]; // Start at 1 to account for duplicate
    var ref5 = (0,external_React_.useState)(""), liveRegionMessage = ref5[0], setLiveRegionMessage = ref5[1];
    var ref6 = (0,external_React_.useState)(false), isVideoFullMode = ref6[0], setIsVideoFullMode = ref6[1]; // Tracks when user is watching video with full controls
    var ref7 = (0,external_React_.useState)(null), transitionDirection = ref7[0], setTransitionDirection = ref7[1]; // 'next' | 'prev' | null - for parallax effect
    var carouselRef = (0,external_React_.useRef)(null);
    var progressCircle = (0,external_React_.useRef)(null);
    var timerRef = (0,external_React_.useRef)(null);
    var timeLeftRef = (0,external_React_.useRef)(null);
    var prevSlideIndexRef = (0,external_React_.useRef)(activeSlideIndex);
    var touchStateRef = (0,external_React_.useRef)({
        startTime: null,
        startX: null,
        startY: null,
        wasAutoPlaying: null
    });
    var transitionTimeoutRef = (0,external_React_.useRef)(null);
    var getSlideDelay = useGetSlideDelay();
    var mobileMediaQuery = (0,useBreakpoint/* useBreakpoint */.G)("lt", "s");
    var isMobile = (0,useMatchMedia/* useMatchMedia */.a)(mobileMediaQuery);
    var prefersReducedMotion = (0,useMatchMedia/* useMatchMedia */.a)("(prefers-reduced-motion: reduce)");
    var ref8;
    var slidesFullControlsEnabled = (ref8 = slides === null || slides === void 0 ? void 0 : slides.some(function(slide) {
        return (slide === null || slide === void 0 ? void 0 : slide.controlOptions) && Object.keys(slide.controlOptions).length > 0;
    })) !== null && ref8 !== void 0 ? ref8 : false;
    var colorTheme = (ref = slides[activeSlideIndex]) === null || ref === void 0 ? void 0 : ref.colorTheme;
    // Initialize carousel utility functions
    var ref9 = useCarouselUtils({
        activeSlideIndex: activeSlideIndex,
        carouselRef: carouselRef,
        currentTransformIndex: currentTransformIndex,
        getSlideDelay: getSlideDelay,
        isAutoPlaying: isAutoPlaying,
        isMobile: isMobile,
        isTransitioning: isTransitioning,
        prefersReducedMotion: prefersReducedMotion,
        progressCircle: progressCircle,
        setActiveSlideIndex: setActiveSlideIndex,
        setCurrentTransformIndex: setCurrentTransformIndex,
        setIsTransitioning: setIsTransitioning,
        setTransitionDirection: setTransitionDirection,
        slides: slides,
        slidesFullControlsEnabled: slidesFullControlsEnabled,
        timeLeftRef: timeLeftRef,
        timerRef: timerRef,
        touchStateRef: touchStateRef,
        transitionTimeoutRef: transitionTimeoutRef,
        translations: translations
    }), pauseVideo = ref9.pauseVideo, restartVideo = ref9.restartVideo, resumeVideo = ref9.resumeVideo, stopAllVideos = ref9.stopAllVideos, stopInactiveVideos = ref9.stopInactiveVideos, isActiveSlideVideo = ref9.isActiveSlideVideo, updateFocusableElements = ref9.updateFocusableElements, goToSlide = ref9.goToSlide, goToNextSlide = ref9.goToNextSlide, goToPrevSlide = ref9.goToPrevSlide, startAutoplay = ref9.startAutoplay, stopAutoplay = ref9.stopAutoplay, handleTouchStart = ref9.handleTouchStart, handleTouchEnd = ref9.handleTouchEnd, handleTouchCancel = ref9.handleTouchCancel;
    // Event handlers
    var handlePrevClick = (0,external_React_.useCallback)(function() {
        goToPrevSlide();
        dispatch(src/* actions.analyticsActions.track */.Nw.analyticsActions.track((0,_define_property._)({
            eventName: constants/* eventNames.AUTOPLAY_PREVIOUS_CLICK */.Sv.AUTOPLAY_PREVIOUS_CLICK
        }, constants/* analyticsProperties.CLICK_ACTIVITY */.pe.CLICK_ACTIVITY, constants/* clickActivityProperties */.ru[constants/* eventNames.AUTOPLAY_PREVIOUS_CLICK */.Sv.AUTOPLAY_PREVIOUS_CLICK])));
    }, [
        goToPrevSlide,
        dispatch
    ]);
    var handleNextClick = (0,external_React_.useCallback)(function() {
        goToNextSlide();
        dispatch(src/* actions.analyticsActions.track */.Nw.analyticsActions.track((0,_define_property._)({
            eventName: constants/* eventNames.AUTOPLAY_NEXT_CLICK */.Sv.AUTOPLAY_NEXT_CLICK
        }, constants/* analyticsProperties.CLICK_ACTIVITY */.pe.CLICK_ACTIVITY, constants/* clickActivityProperties */.ru[constants/* eventNames.AUTOPLAY_NEXT_CLICK */.Sv.AUTOPLAY_NEXT_CLICK])));
    }, [
        goToNextSlide,
        dispatch
    ]);
    var handlePlayPauseClick = (0,external_React_.useCallback)(function() {
        var newIsAutoPlaying = !isAutoPlaying;
        setIsAutoPlaying(newIsAutoPlaying);
        // Announce autoplay state change to screen readers
        setLiveRegionMessage(newIsAutoPlaying ? translations.autoplayResumeButtonLabel || "Carousel autoplay resumed" : translations.autoplayPauseButtonLabel || "Carousel autoplay paused");
        // Handle video play/pause
        if (isActiveSlideVideo()) {
            if (newIsAutoPlaying) {
                resumeVideo();
            } else {
                pauseVideo();
            }
        }
        var eventName = newIsAutoPlaying ? constants/* eventNames.AUTOPLAY_PLAY */.Sv.AUTOPLAY_PLAY : constants/* eventNames.AUTOPLAY_PAUSE */.Sv.AUTOPLAY_PAUSE;
        dispatch(src/* actions.analyticsActions.track */.Nw.analyticsActions.track((0,_define_property._)({
            eventName: eventName
        }, constants/* analyticsProperties.CLICK_ACTIVITY */.pe.CLICK_ACTIVITY, constants/* clickActivityProperties */.ru[eventName])));
    }, [
        isAutoPlaying,
        dispatch,
        isActiveSlideVideo,
        resumeVideo,
        pauseVideo,
        translations, 
    ]);
    // Keyboard navigation handler
    var handleKeyDown = (0,external_React_.useCallback)(function(e) {
        // Prevent navigation when user is in video full mode
        if (isVideoFullMode) {
            return;
        }
        // Only handle keyboard events when carousel container or its controls have focus
        if (e.key === "ArrowLeft") {
            e.preventDefault();
            handlePrevClick();
        } else if (e.key === "ArrowRight") {
            e.preventDefault();
            handleNextClick();
        } else if (e.key === "Home") {
            e.preventDefault();
            goToSlide(0);
        } else if (e.key === "End") {
            e.preventDefault();
            goToSlide(slides.length - 1);
        }
    }, [
        handlePrevClick,
        handleNextClick,
        goToSlide,
        slides.length,
        isVideoFullMode, 
    ]);
    // Handler for video overlay controls (WATCH button and back button)
    var handleAutoplayControl = (0,external_React_.useCallback)(function(action) {
        if (action === "pause") {
            setIsAutoPlaying(false);
            setIsVideoFullMode(true);
            stopAutoplay();
        } else if (action === "resume") {
            setIsAutoPlaying(true);
            setIsVideoFullMode(false);
            // Restart the video from the beginning when exiting full mode
            if (isActiveSlideVideo()) {
                restartVideo();
            }
        }
    }, [
        stopAutoplay,
        isActiveSlideVideo,
        restartVideo
    ]);
    // Effects
    (0,external_React_.useEffect)(function() {
        var ref, ref1;
        updateFocusableElements(activeSlideIndex);
        // Reset video full mode when slide changes
        // This ensures controls are restored if user navigates away from video slide
        if (isVideoFullMode) {
            setIsVideoFullMode(false);
        }
        // Announce slide change to screen readers
        var slideNumber = activeSlideIndex + 1;
        var totalSlides = slides.length;
        var message = ((ref1 = (ref = translations.slideChanged) === null || ref === void 0 ? void 0 : ref.replace("{current}", slideNumber)) === null || ref1 === void 0 ? void 0 : ref1.replace("{total}", totalSlides)) || "Slide ".concat(slideNumber, " of ").concat(totalSlides);
        setLiveRegionMessage(message);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        activeSlideIndex,
        updateFocusableElements,
        slides.length,
        translations
    ]);
    // Video management effect - stop inactive videos and resume active video when slide changes
    (0,external_React_.useEffect)(function() {
        // After transition completes, stop and reset videos on inactive slides
        if (!isTransitioning && (slides === null || slides === void 0 ? void 0 : slides.length) > 0) {
            stopInactiveVideos();
            var slideActuallyChanged = prevSlideIndexRef.current !== activeSlideIndex;
            // If we navigated to a video slide while autoplay is on, ensure video plays
            // This handles the case where video was paused via carousel pause button,
            // then autoplay was resumed, then user navigated back to the video slide
            if (slideActuallyChanged && isActiveSlideVideo() && isAutoPlaying) {
                resumeVideo();
            }
            // Track slide changes
            if (slideActuallyChanged) {
                prevSlideIndexRef.current = activeSlideIndex;
            }
        }
    }, [
        activeSlideIndex,
        isAutoPlaying,
        isActiveSlideVideo,
        isTransitioning,
        resumeVideo,
        slides === null || slides === void 0 ? void 0 : slides.length,
        stopInactiveVideos, 
    ]);
    // Autoplay effect
    (0,external_React_.useEffect)(function() {
        if (isAutoPlaying && !isTransitioning) {
            startAutoplay();
        } else {
            stopAutoplay();
        }
        return function() {
            stopAutoplay();
        };
    }, [
        isAutoPlaying,
        activeSlideIndex,
        isTransitioning,
        startAutoplay,
        stopAutoplay, 
    ]);
    // Slides synchronization effect - reset state when slides change to prevent invalid indices
    (0,external_React_.useEffect)(function() {
        var ref;
        var totalSlides = (ref = slides === null || slides === void 0 ? void 0 : slides.length) !== null && ref !== void 0 ? ref : 0;
        if (totalSlides === 0) return;
        // Clamp activeSlideIndex to valid range if slides array shrinks
        if (activeSlideIndex >= totalSlides) {
            // Clear any pending transition timeout to prevent stale closure execution
            if (transitionTimeoutRef.current) {
                clearTimeout(transitionTimeoutRef.current);
                transitionTimeoutRef.current = null;
            }
            stopAutoplay();
            setActiveSlideIndex(0);
            setCurrentTransformIndex(1); // Reset to start position (accounting for duplicate)
            setIsTransitioning(false); // Reset transition state
            stopAllVideos();
            prevSlideIndexRef.current = 0;
            // Reset progress to 0 to prevent startAutoplay from using stale progress values
            if (progressCircle.current) {
                progressCircle.current.style.setProperty("--progress", 0);
            }
        }
    }, [
        slides === null || slides === void 0 ? void 0 : slides.length,
        activeSlideIndex,
        stopAllVideos,
        stopAutoplay
    ]);
    // Cleanup effect - stop ALL videos and clear pending timeouts when component unmounts
    (0,external_React_.useEffect)(function() {
        return function() {
            stopAllVideos();
            // Clear any pending transition timeout to prevent state updates on unmounted component
            if (transitionTimeoutRef.current) {
                clearTimeout(transitionTimeoutRef.current);
                transitionTimeoutRef.current = null;
            }
        };
    }, [
        stopAllVideos
    ]);
    var _obj;
    // Component styles
    var carouselClasses = (0,clsx_m/* default */.Z)(autoplayCarousel.autoplayCarousel, (_obj = {}, (0,_define_property._)(_obj, autoplayCarousel.dark, colorTheme === shapes/* THEMES.DARK */.yU.DARK), (0,_define_property._)(_obj, autoplayCarousel.transitioning, isTransitioning), _obj));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: carouselClasses,
        id: "carousel-".concat(cardId),
        role: "region",
        "aria-label": translations.autoplayCarousel || "Autoplay Carousel",
        onKeyDown: handleKeyDown,
        onTouchStart: function(e) {
            return !isVideoFullMode && handleTouchStart(e, stopAutoplay);
        },
        onTouchEnd: function(e) {
            return !isVideoFullMode && handleTouchEnd(e, handleNextClick, handlePrevClick, startAutoplay);
        },
        onTouchCancel: function() {
            return !isVideoFullMode && handleTouchCancel(startAutoplay);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: autoplayCarousel.slidesContainer,
                ref: carouselRef,
                style: {
                    transform: "translateX(-".concat(currentTransformIndex * 100, "%)"),
                    transition: isTransitioning && !prefersReducedMotion ? "transform ".concat(TRANSITION_DURATION, "ms ease-in-out") : "none"
                },
                children: slides && slides.length > 0 && // Last slide duplicate (for seamless backward scroll)
                (0,_to_consumable_array._)(slides.slice(-1).map(function(slide) {
                    var actualIndex = slides.length - 1;
                    var ref;
                    var slideKey = (ref = slide === null || slide === void 0 ? void 0 : slide.id) !== null && ref !== void 0 ? ref : "slide-".concat(actualIndex);
                    var _obj;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)(autoplayCarousel.slide, (_obj = {}, (0,_define_property._)(_obj, autoplayCarousel.parallaxNext, isTransitioning && transitionDirection === "next" && currentTransformIndex === 0 && !prefersReducedMotion), (0,_define_property._)(_obj, autoplayCarousel.parallaxPrev, isTransitioning && transitionDirection === "prev" && currentTransformIndex === 0 && !prefersReducedMotion), _obj)),
                        "data-slide-delay": getSlideDelay(slide),
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoplayCarouselSlide, (0,_object_spread_props._)((0,_object_spread._)({}, slide), {
                            cardId: cardId,
                            index: actualIndex,
                            analyticsItemId: "".concat(analyticsItemId, "_").concat(actualIndex + 1),
                            itemCount: slides.length,
                            collectionId: analyticsItemId,
                            hashKey: slide.hashKey || hashKey,
                            onAutoplayControl: handleAutoplayControl
                        }))
                    }, "duplicate-last-".concat(slideKey));
                })).concat(// Original slides
                (0,_to_consumable_array._)(slides.map(function(slide, index) {
                    var ref, ref1, ref2, ref3;
                    var slideDelay = getSlideDelay(slide);
                    var isVideo = (slide === null || slide === void 0 ? void 0 : (ref = slide.containerType) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === "VIDEO";
                    var mediaType = isVideo ? "video" : "image";
                    var slideTitle = slide === null || slide === void 0 ? void 0 : (ref1 = slide.titleProps) === null || ref1 === void 0 ? void 0 : ref1.text;
                    var titleSuffix = slideTitle ? ": ".concat(slideTitle) : "";
                    var ref4;
                    var slideKey = (ref4 = slide === null || slide === void 0 ? void 0 : slide.id) !== null && ref4 !== void 0 ? ref4 : "slide-".concat(index);
                    var slideNumber = index + 1;
                    var baseLabel = ((ref3 = (ref2 = translations.autoplaySlideNumber) === null || ref2 === void 0 ? void 0 : ref2.replace("{slideNum}", slideNumber)) === null || ref3 === void 0 ? void 0 : ref3.replace("{slidesTotalNum}", slides.length)) || "Slide ".concat(slideNumber, " of ").concat(slides.length);
                    var slideLabel = "".concat(baseLabel, ", ").concat(mediaType).concat(titleSuffix);
                    var _obj;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)(autoplayCarousel.slide, (_obj = {}, (0,_define_property._)(_obj, autoplayCarousel.parallaxNext, isTransitioning && transitionDirection === "next" && index + 1 === currentTransformIndex && !prefersReducedMotion), (0,_define_property._)(_obj, autoplayCarousel.parallaxPrev, isTransitioning && transitionDirection === "prev" && index + 1 === currentTransformIndex && !prefersReducedMotion), _obj)),
                        "data-slide-delay": slideDelay,
                        role: "group",
                        "aria-label": slideLabel,
                        "aria-hidden": index !== activeSlideIndex,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoplayCarouselSlide, (0,_object_spread_props._)((0,_object_spread._)({}, slide), {
                            cardId: cardId,
                            index: index,
                            analyticsItemId: "".concat(analyticsItemId, "_").concat(index + 1),
                            itemCount: slides.length,
                            collectionId: analyticsItemId,
                            hashKey: slide.hashKey || hashKey,
                            onAutoplayControl: handleAutoplayControl
                        }))
                    }, slideKey);
                })), // First slide duplicate (for seamless forward scroll)
                (0,_to_consumable_array._)(slides.slice(0, 1).map(function(slide) {
                    var ref;
                    var slideKey = (ref = slide === null || slide === void 0 ? void 0 : slide.id) !== null && ref !== void 0 ? ref : "slide-0";
                    var _obj;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)(autoplayCarousel.slide, (_obj = {}, (0,_define_property._)(_obj, autoplayCarousel.parallaxNext, isTransitioning && transitionDirection === "next" && currentTransformIndex === slides.length + 1 && !prefersReducedMotion), (0,_define_property._)(_obj, autoplayCarousel.parallaxPrev, isTransitioning && transitionDirection === "prev" && currentTransformIndex === slides.length + 1 && !prefersReducedMotion), _obj)),
                        "data-slide-delay": getSlideDelay(slide),
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoplayCarouselSlide, (0,_object_spread_props._)((0,_object_spread._)({}, slide), {
                            cardId: cardId,
                            index: 0,
                            analyticsItemId: "".concat(analyticsItemId, "_1"),
                            itemCount: slides.length,
                            collectionId: analyticsItemId,
                            hashKey: slide.hashKey || hashKey,
                            onAutoplayControl: handleAutoplayControl
                        }))
                    }, "duplicate-first-".concat(slideKey));
                })))
            }),
            !isVideoFullMode && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: autoplayCarousel.controls,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressPauseButton, {
                                colorTheme: colorTheme,
                                isAutoPlaying: isAutoPlaying,
                                progressCircleRef: progressCircle,
                                onPlayPauseClick: handlePlayPauseClick,
                                translations: translations
                            }),
                            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationButtons, {
                                colorTheme: colorTheme,
                                onPrevClick: handlePrevClick,
                                onNextClick: handleNextClick,
                                translations: translations
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationIndicators, {
                        slides: slides,
                        activeSlideIndex: activeSlideIndex,
                        onSlideClick: goToSlide,
                        paginationLabel: "".concat(translations.autoplayCarousel, " ").concat(translations.paginationTitle)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "aria-live": "polite",
                "aria-atomic": "true",
                className: "sr-only",
                style: srOnlyStyles,
                children: liveRegionMessage
            })
        ]
    });
};
AutoplayCarousel.propTypes = {
    analyticsItemId: (prop_types_default()).string,
    cardId: (prop_types_default()).string,
    hashKey: (prop_types_default()).string,
    slides: prop_types_default().arrayOf(prop_types_default().shape(shapes/* gallerySlideShape */.zA)),
    translations: prop_types_default().objectOf((prop_types_default()).string)
};

;// CONCATENATED MODULE: ../ciclp-react-components/src/components/autoplayCarousel/index.js






/***/ })

}]);